/* ──────────────────────────────────────────────────────────────
   LG Category Pills — flèches de navigation desktop
   ──────────────────────────────────────────────────────────────

   Ajoute des flèches précédent/suivant aux rangées de pilules
   scrollables, uniquement sur appareils avec souris.

   Fonctionnalités :
   - Détection automatique des rangées qui débordent
   - Masquage de la flèche gauche quand on est au début
   - Masquage de la flèche droite quand on est à la fin
   - Recalcul automatique au scroll, au resize, et quand le dropdown
     mega-menu s'ouvre (via ResizeObserver sur le scroller)
   - Respect de prefers-reduced-motion

   Installation : référencer via
     <script src="{{ 'lg-category-pills.js' | asset_url }}" defer></script>
   dans theme.liquid, section LeGarage.
   ────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  // Uniquement sur appareils avec souris (pas sur tactile)
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

  function createArrow(direction, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-pills__arrow lg-pills__arrow--' + direction;
    btn.setAttribute('aria-label', label);
    var path = direction === 'prev' ? 'M9 3 5 7l4 4' : 'M5 3l4 4-4 4';
    btn.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
        '<path d="' + path + '" stroke="currentColor" stroke-width="1.4" ' +
        'stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
      '</svg>';
    return btn;
  }

  function init(pills) {
    if (pills.dataset.lgArrowsInit === 'true') return;

    var scroller = pills.querySelector('.lg-pills__scroller');
    if (!scroller) return;

    pills.dataset.lgArrowsInit = 'true';

    // Envelopper le scroller pour positionner les flèches
    var wrap = document.createElement('div');
    wrap.className = 'lg-pills__scroller-wrap';
    scroller.parentNode.insertBefore(wrap, scroller);
    wrap.appendChild(scroller);

    var prev = createArrow('prev', 'Défiler vers la gauche');
    var next = createArrow('next', 'Défiler vers la droite');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function scrollDistance() {
      return scroller.clientWidth * 0.8;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -scrollDistance(), behavior: scrollBehavior });
    });

    next.addEventListener('click', function () {
      scroller.scrollBy({ left: scrollDistance(), behavior: scrollBehavior });
    });

    function updateState() {
      var sl = scroller.scrollLeft;
      var sw = scroller.scrollWidth;
      var cw = scroller.clientWidth;
      var hasOverflow = sw > cw + 2;

      wrap.classList.toggle('has-overflow', hasOverflow);
      wrap.classList.toggle('is-at-start', sl <= 2);
      wrap.classList.toggle('is-at-end', sl + cw >= sw - 2);
    }

    scroller.addEventListener('scroll', updateState, { passive: true });

    // ResizeObserver détecte aussi l'ouverture du dropdown mega-menu
    // (le scroller passe de width 0 à width X)
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateState).observe(scroller);
    } else {
      window.addEventListener('resize', updateState);
    }

    // Re-check après chargement des images (scrollWidth peut changer)
    var images = scroller.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].complete) {
        images[i].addEventListener('load', updateState, { once: true });
      }
    }

    updateState();
  }

  function initAll() {
    var all = document.querySelectorAll('.lg-pills');
    for (var i = 0; i < all.length; i++) {
      init(all[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Observer pour les pilules injectées dynamiquement (rare mais safe)
  if (typeof MutationObserver !== 'undefined' && document.body) {
    var mo = new MutationObserver(function () {
      var fresh = document.querySelectorAll('.lg-pills:not([data-lg-arrows-init])');
      for (var i = 0; i < fresh.length; i++) {
        init(fresh[i]);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();